<template>
  <section>
    <Materiais :segmento="0"/>
    <br>
    <Uniforme/>
    <br>
  </section>
</template>

<script>
import Uniforme from "../lateral/Uniforme";
import Materiais from "../lateral/Materiais";

export default {
  props: { segmento: Number },
  data: () => ({}),
  components: {
    Uniforme,
    Materiais
  }
};
</script>

<style lang="scss" scoped>
p,
h2,
ul li,
ol li {
  text-align: left !important;
}
</style>



